import {
  UserAuthenticationSetting,
  UserAuthenticationSettingForm,
  UserAuthenticationSettingResponse,
} from 'types/userAuthentication';

import { api } from './setupApi';

class UserAuthenticationSettingModel {
  link = '/user_authentication_setting';

  getSetting = (): Promise<UserAuthenticationSetting> =>
    api.get<UserAuthenticationSetting>(this.link).then(({ data }) => data);

  updateSetting = (data: UserAuthenticationSettingForm): Promise<UserAuthenticationSettingResponse> =>
    api.patch<UserAuthenticationSettingResponse>(this.link, data).then(({ data }) => data);

  deleteSetting = (): Promise<{ success: string[] }> =>
    api.delete<{ success: string[] }>(this.link).then(({ data }) => data);
}

export const userAuthenticationSettingModel = new UserAuthenticationSettingModel();
